<proffeo-ui-button
  (clicked)="exportToExcel()"
  [ariaLabel]="'time-reports-export.export-button'"
  variant="primary"
  fontIcon="superscript"
  text="time-reports-export.export-button"
  class="min-[960px]:hidden shrink-0"
/>
